import _implicitStylesheets from "./installMethodDropdown.css";
import _implicitScopedStylesheets from "./installMethodDropdown.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<option${"a0:value"} selected${3}>${"t1"}</option>`;
const $fragment2 = parseFragment`<option${"a0:value"}${3}>${"t1"}</option>`;
const stc0 = {
  classMap: {
    "dropdown": true
  },
  key: 0
};
const stc1 = {
  "dropdown-select": true
};
const stc2 = {
  classMap: {
    "dropdown-chevron": true
  },
  props: {
    "icon": "chevrondown",
    "theme": "default",
    "size": "xsmall",
    "ariaHidden": "true"
  },
  key: 6
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, k: api_key, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, i: api_iterator, h: api_element, c: api_custom_element} = $api;
  const {_m0} = $ctx;
  return [api_element("div", stc0, [api_element("select", {
    classMap: stc1,
    attrs: {
      "aria-label": $cmp.ariaLabel
    },
    key: 1,
    on: {
      "change": _m0 || ($ctx._m0 = api_bind($cmp.handleChange))
    }
  }, api_iterator($cmp.optionsWithSelection, function (option) {
    return [option.selected ? api_static_fragment($fragment1, api_key(3, option.id), [api_static_part(0, {
      attrs: {
        "value": option.id
      }
    }, null), api_static_part(1, null, api_dynamic_text(option.label))]) : null, !option.selected ? api_static_fragment($fragment2, api_key(5, option.id), [api_static_part(0, {
      attrs: {
        "value": option.id
      }
    }, null), api_static_part(1, null, api_dynamic_text(option.label))]) : null];
  })), api_custom_element("ax-icon", _axIcon, stc2)])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7ckcvtpj5ah";
tmpl.legacyStylesheetToken = "undefined-_installMethodDropdown";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
